// extracted by mini-css-extract-plugin
module.exports = {"calendar":"OBTYearFieldDialog_calendar__1tYVt","visible":"OBTYearFieldDialog_visible__2fZlA","label":"OBTYearFieldDialog_label__20idT"};